
const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-4xl font-bold text-gray-900 mb-6">
              信頼と実績の
              <span className="text-blue-600">TOUAREG GLOBAL</span>
            </h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              私たちは15年以上にわたり、お客様の資産形成と財務目標の達成をサポートしてきました。
              経験豊富な専門家チームが、一人ひとりのニーズに合わせたオーダーメイドの投資戦略を提供します。
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              グローバルな視点と地域に根ざした知識を組み合わせ、
              リスク管理を重視した安定的なリターンの実現を目指しています。
            </p>
            
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="text-center p-6 bg-white rounded-lg shadow-sm">
                <div className="text-3xl font-bold text-blue-600 mb-2">500+</div>
                <div className="text-gray-600">満足いただいたクライアント</div>
              </div>
              <div className="text-center p-6 bg-white rounded-lg shadow-sm">
                <div className="text-3xl font-bold text-blue-600 mb-2">¥100億+</div>
                <div className="text-gray-600">運用資産総額</div>
              </div>
              <div className="text-center p-6 bg-white rounded-lg shadow-sm">
                <div className="text-3xl font-bold text-blue-600 mb-2">15年</div>
                <div className="text-gray-600">業界経験</div>
              </div>
              <div className="text-center p-6 bg-white rounded-lg shadow-sm">
                <div className="text-3xl font-bold text-blue-600 mb-2">98%</div>
                <div className="text-gray-600">顧客満足度</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/3d20d89dea620ac915c43e1b72f4451e.jpg"
              alt="TOUAREG GLOBALのプロフェッショナルチーム"
              className="rounded-lg shadow-lg object-cover w-full h-[500px]"
            />
            <div className="absolute -bottom-6 -left-6 bg-blue-600 text-white p-6 rounded-lg shadow-lg">
              <div className="text-2xl font-bold mb-1">お客様第一</div>
              <div className="text-blue-100">私たちの基本理念</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
